import SeekerEmailNotificationSettings from "./SeekerEmailNotificationSettings";

export default SeekerEmailNotificationSettings;